import React, { useEffect, useState } from 'react';
import EarlyAccessModel from '../../components/EarlyAccess';
import { useDispatch } from 'react-redux';
import getSymbolFromCurrency from 'currency-symbol-map';
import countryToCurrency from 'country-to-currency';

import LandingScreenFooter from '../../components/LandingFooter';
import './index.css';
import { BsFillCheckCircleFill } from 'react-icons/bs';
import { BsCheckCircleFill } from 'react-icons/bs';
import LandingPageHeader from '../../components/LandingpageHeader';
import { postApi } from '../../services/api';

const PricingScreen = function () {
	const dispatch = useDispatch();
	return (
		<div className="app-container">
			<LandingPageHeader />
			<PricingComponent />

			{/* <div>
				<div className="pricing-container">
					<h2 className="head-1">The most unique way of payment you’ve ever seen in the market</h2>
					<h3 className="head-2">“Pay us through your monthly office waste”</h3>
					<div className="head-3">
						Use of our product to stremline your company’s IT assets <br /> Manage, assign, dispose, and
						calculate depreciation
					</div>
					<div className="content-1">
						<div className="points">
							<div className="head-1">
								Your regular office waste is all you need to pay for the software
							</div>
							<div className="all-points">
								<div className={'each-point'}>
									<BsFillCheckCircleFill />
									Coffee cups
								</div>
								<div className={'each-point'}>
									<BsFillCheckCircleFill />
									Newspapers
								</div>
								<div className={'each-point'}>
									<BsFillCheckCircleFill />
									Printing papers
								</div>
								<div className={'each-point'}>
									<BsFillCheckCircleFill />
									Cardboards
								</div>
								<div className={'each-point'}>
									<BsFillCheckCircleFill />
									Magazines
								</div>
								<div className={'each-point'}>
									<BsFillCheckCircleFill />
									Aluminum cans
								</div>
								<div className={'each-point'}>
									<BsFillCheckCircleFill />
									Batteries
								</div>
								<div className={'each-point'}>
									<BsFillCheckCircleFill />
									Printer cartridges
								</div>
								<div className={'each-point'}>
									<BsFillCheckCircleFill />
									Cables
								</div>
							</div>
						</div>
						<div className="image-container">
							<img src={require('../../images/price1.png')} alt="cash for trash" />
						</div>
					</div>
					<div className="divider"></div>
					<div className="content-2">
						<div>
							<img src={require('../../images/price2.png')} alt={'office e-waste'} />
						</div>
						<div className="content-container">
							<div className="head-1">
								Sell your office E-waste <br /> at Attractive Price
							</div>
							<div className="head-2">
								Reduce the pile of waste from your office <br /> by recycling it.
							</div>
							<div className="all-points">
								<div className={'each-point'}>
									<BsFillCheckCircleFill />
									Get best prices for your E-waste
								</div>
								<div className={'each-point'}>
									<BsFillCheckCircleFill />
									Helps environment from toxic waste
								</div>
								<div className={'each-point'}>
									<BsFillCheckCircleFill />
									Saves money to the company
								</div>
							</div>
							<EarlyAccessModel className="request-quote" content="Request Quote" />
						</div>
					</div>
				</div>
			</div> */}
			<LandingScreenFooter />
		</div>
	);
};

export default PricingScreen;

const basicInfo = [
	'Asset management',
	'Incident Management',
	'Ticketing system',
	'Master Admin',
	'Unlimited Assets',
	'Assign/Unassign Assets',
	'Auto Asset Tagging',
	'Analytics',
	'Employee portal',
	'Depreciation Calculation',
];

const growthInfo = [
	'Asset management',
	'Incident Management',
	'Ticketing system',
	'Master Admin',
	'Unlimited Assets',
	'Assign/Unassign Assets',
	'Auto Asset Tagging',
	'Analytics',
	'Employee portal',
	'Depreciation Calculation',
	'IT Health calculation',
	'Vendor Management',
	'Contract Management',
];

const premiumInfo = [
	'Asset management',
	'Incident Management',
	'Ticketing system',
	'Master Admin',
	'Unlimited Assets',
	'Assign/Unassign Assets',
	'Auto Asset Tagging',
	'Analytics',
	'Employee portal',
	'Depreciation Calculation',
	'IT Health calculation',
	'Vendor Management',
	'Contract Management',
	'Consulting',
	'Cyber Security - WFH',
	'Monthly Maintenance',
];

const PricingComponent = () => {
	const [countryCode, setCountryCode] = useState('INR');
	const [currencySymbol, setCurrencySymbol] = useState('INR');
	useEffect(() => {
		// const getCountryInfo = async function () {
		// 	const resp = await postApi({}, '/acess-geoip');
		// 	if (resp.type === 'success') {
		// 		localStorage.setItem('countryInfo', JSON.stringify(resp.data));
		// 	}
		// };
		// const countryCodeExist = localStorage.getItem('countryInfo');
		// console.log(countryCodeExist, 'country_code');
		// if (!countryCodeExist) {
		// 	getCountryInfo();
		// } else {
		// 	setCountryCode(JSON.parse(countryCodeExist).country_code);
		// }
	}, []);

	useEffect(() => {
		console.log(getSymbolFromCurrency(countryCode));
		console.log(getSymbolFromCurrency('AE'));
		console.log(getSymbolFromCurrency('US'));
		console.log(getSymbolFromCurrency('INR'));
		if (countryCode) {
			setCurrencySymbol(getSymbolFromCurrency(countryToCurrency[countryCode]));
		}
	}, [countryCode]);

	console.log(currencySymbol, countryCode);
	return (
		<>
			<div className="pricing-content-container">
				<PricingTopView countryCode={countryCode} />

				<div className="pricing-content-1">
					<div>
						<p>Your regular office waste is all you need to pay for the software</p>
						<img src={require('../../images/coffe.png')} />
					</div>
					<div className="trashcan-image-container">
						<img src={require('../../images/pricing11.png')} />
					</div>
				</div>
			</div>
			<div className="pricing-content-2">
				<div className="ewaste-imagecontainer">
					<img src={require('../../images/pricing12.png')} />
				</div>
				<div className="contents">
					<h2>Sell your office E-waste at Attractive Price</h2>
					<div>Reduce the pile of waste from your office by recycling it.</div>
					<div className="each-list-item">
						<BsCheckCircleFill /> Get best prices for your E-waste
					</div>
					<div className="each-list-item">
						<BsCheckCircleFill /> Helps environment from toxic waste
					</div>
					<div className="each-list-item">
						<BsCheckCircleFill /> Saves money to the company
					</div>
					<EarlyAccessModel className={'button-action'} content={'Sign Up'} />
				</div>
			</div>
			<div className="pricing-content-3">
				<div className="table-header">
					<div className="each-header">
						<div>Basic</div>
						<div>For getting started</div>
						<EarlyAccessModel className={'select-plan'} content="Select Plan" />
					</div>
					<div className="each-header">
						<div>Premium</div>
						<div>For growing businesses</div>
						<EarlyAccessModel className={'select-plan'} content="Select Plan" />
					</div>
					<div className="each-header">
						<div>Enterprise</div>
						<div>Solution for enterprises</div>
						<EarlyAccessModel className={'select-plan'} content="Select Plan" />
					</div>
				</div>
				<div className="table-content">
					<div className="eachtable-content">
						{basicInfo.map((el) => (
							<div className="eachtable-info">
								<BsCheckCircleFill />
								{el}
							</div>
						))}
					</div>
					<div className="eachtable-content">
						{growthInfo.map((el) => (
							<div className="eachtable-info">
								<BsCheckCircleFill />
								{el}
							</div>
						))}
					</div>
					<div className="eachtable-content">
						{premiumInfo.map((el) => (
							<div className="eachtable-info">
								<BsCheckCircleFill />
								{el}
							</div>
						))}
					</div>
				</div>

				<TableFooter countryCode={countryCode} />
			</div>
		</>
	);
};

const TableFooter = ({ countryCode }) => {
	if (countryCode === 'US') {
		return (
			<div className="table-footer">
				<div className="each-footer">
					<div>
						<span>$0.05 </span>
						<br />/ Asset/ Month
					</div>
				</div>
				<div className="each-footer">
					<div>
						<span>$0.1</span> <br /> / Asset/ Month
					</div>
				</div>
				<div className="each-footer">
					<div>
						<span>$0.15</span> <br /> / Asset/ Month
					</div>
				</div>
			</div>
		);
	}

	if (countryCode === 'AE') {
		return (
			<div className="table-footer">
				<div className="each-footer">
					<div>
						<span>AED 0.18</span> <br /> / Asset/ Month
					</div>
				</div>
				<div className="each-footer">
					<div>
						<span>AED 0.37</span> <br /> / Asset/ Month
					</div>
				</div>
				<div className="each-footer">
					<div>
						<span>AED 0.55</span> <br /> / Asset/ Month
					</div>
				</div>
			</div>
		);
	}

	return (
		<div className="table-footer">
			<div className="each-footer">
				<div>Monthly Waste*</div>
			</div>
			<div className="each-footer">
				<div>
					Monthly Waste* + <br /> E-waste
				</div>
			</div>
			<div className="each-footer">
				<div>
					All types of <br /> Waste*
				</div>
			</div>
		</div>
	);
};

const PricingTopView = ({ countryCode }) => {
	if (countryCode === 'IN') {
		return (
			<>
				<h1>Money is Passe´</h1>
				<h4>Re-introducing the “Barter”</h4>
				<div className="list">
					<ul>
						<li>Companies use our product and in-turn provide their monthly waste products </li>
						<li>Our product is loved by companies that are across the globe</li>
					</ul>
				</div>
			</>
		);
	}
	return (
		<>
			<h1>No Complications at all!</h1>
			<h4>Just simple pricing</h4>
			<div className="list">
				<ul>
					<li>Assetze is loved by startups and enterprizes equally across the globe</li>
					<li>Affordable pricing to all stage businesses</li>
				</ul>
			</div>
		</>
	);
};
